var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","text-align-last":"center","text-align":"center","background-color":"rgba(74, 74, 74,"}},[_c('CubeLoader'),_c('p',{staticClass:"centered loadingText"},[_vm._v(_vm._s(_vm.textOptions[0]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }